import type { Especie, Perfil } from "@vetbolso/contracts";

export const ESPECIES_INFO: readonly { id: Especie; nome: string }[] = [
  { id: "cao", nome: "Cão" },
  { id: "gato", nome: "Gato" },
  { id: "bovino", nome: "Bovino" },
  { id: "equino", nome: "Equino" },
];
export const PERFIS_INFO: readonly { id: Perfil; nome: string }[] = [
  { id: "vet", nome: "Veterinário" },
  { id: "farmacia", nome: "Farmácia" },
  { id: "agro", nome: "Agropecuária" },
  { id: "estudante", nome: "Estudante" },
];

export const nomeEspecie = (id: string) => ESPECIES_INFO.find((e) => e.id === id)?.nome ?? id;
export const pequeno = (e: string) => e === "cao" || e === "gato";

/** Sem lista de espécies, o item vale para todas. */
export const espMatch = (item: { especies?: readonly string[] }, e: string) =>
  !item.especies || item.especies.includes(e) || item.especies.includes("todas");
